// TickIcon.jsx
const TickIcon = (props) => {
    const { size = "24", status } = props;

    const defaultWidth = 24;
    const defaultHeight = 24;
    const aspectRatio = defaultWidth / defaultHeight;
    const viewBox = `0 0 ${defaultWidth} ${defaultHeight}`

    // Calculate height if only width is provided to maintain aspect ratio
    const height = size || size / aspectRatio;

    let fillColor = "";
    if (status === 4) {
        fillColor = "#1E8DF6"; // Blue color for 'read' status
    } else if (status === 3) {
        fillColor = "#A0A0A0"
    }

    return (

        <svg
            className="svg_icon svg_icon--fill"
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={height}
            viewBox={viewBox}
            fill="none"
            {...props}
        >
            <path fillRule="evenodd" clipRule="evenodd" d="M16.5303 6.46967C16.8232 6.76256 16.8232 7.23744 16.5303 7.53033L6.53033 17.5303C6.38968 17.671 6.19891 17.75 6 17.75C5.80109 17.75 5.61032 17.671 5.46967 17.5303L1.46967 13.5303C1.17678 13.2374 1.17678 12.7626 1.46967 12.4697C1.76256 12.1768 2.23744 12.1768 2.53033 12.4697L6 15.9393L15.4697 6.46967C15.7626 6.17678 16.2374 6.17678 16.5303 6.46967ZM22.5303 6.46966C22.8232 6.76254 22.8232 7.23742 22.5303 7.53032L12.5308 17.5303C12.2379 17.8232 11.7631 17.8232 11.4702 17.5304L9.96975 16.0304C9.67681 15.7376 9.67674 15.2627 9.96959 14.9697C10.2624 14.6768 10.7373 14.6767 11.0303 14.9696L12.0004 15.9394L21.4697 6.46968C21.7625 6.17678 22.2374 6.17677 22.5303 6.46966Z"
                fill={fillColor} />
        </svg>
    );
};

export default TickIcon;
